import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import BaseButton from 'src/Components/Button/BaseButton'

import styles from './RefiOptionCard.module.scss'

const propTypes = {
  className: PropTypes.string
}

const RefiOptionCard = ({ className, onClick, ...restProps }) => (
  <BaseButton
    element='div'
    onClick={onClick}
    className={classnames(styles.root, className)}
    {...restProps}
  />
)

RefiOptionCard.propTypes = propTypes

export default RefiOptionCard
